<h1 mat-dialog-title>{{data ? 'Edit Payment' : 'Add Payment'}}</h1>

<div mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Payer</mat-label>
      <input matInput formControlName="payer">
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Amount</mat-label>
      <input matInput type="number" formControlName="amount">
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Date</mat-label>
      <!-- <input matInput type="date" formControlName="date"> -->
       <input matInput [matDatepicker]="startPicker" formControlName="date" />
    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button color="primary" (click)="save()" [disabled]="form.invalid">Save</button>
</div>

